import React from "react";
import { UserAvatar } from "../../../components/User";
import { useLocaleContext } from "../../../context/LocaleContext";

export default ({ item }) => {
    const { get } = useLocaleContext();
    
    if (!item) return null;

    return <div className="activity-top-card">
        <UserAvatar user={item.client} size='xx-large' />
        <div className="activity-top-user-info">
            <div className="activity-top-user-info__index">{item.index}</div>
            <div className="activity-top-user-info__name">{item.nickname}</div>
            <div className="activity-top-user-info__points">
                <div className="activity-top-user-info__points-label">
                    {get('common.points')}:
                </div>
                {item.points}
            </div>
        </div>
    </div>
}